<template>
    <v-chart class="chart-display" :option="option" autoresize/>
</template>

<script>

import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { GaugeChart } from 'echarts/charts';
import VChart from 'vue-echarts';
import { ref, defineComponent } from 'vue';

use([
  CanvasRenderer,
  GaugeChart,
]);

export default defineComponent({
  name: 'ArcChart',
  components: {
    VChart
  },
  props: ['id'],
  setup(props) {
    (async () => {      try {
        const res = await fetch(`/api/collections/projects/entries/${props.id}`); 
        const { data } = await res.json() 
        option.value.series[0].max = data.project_nearterm_impact_total_potential * 10;
        option.value.series[0].data[0].value = data.project_nearterm_impact_total_adjusted * 10;
      } catch (e) { }
    })()

    const option = ref({
      series: [{
        type: 'gauge',
        startAngle: 180,
        endAngle: 0,
        min: 0,
        itemStyle: {
          color: '#467ED1'
        },
        progress: {
          show: true,
          width: 72
        },
        pointer: {
          show: false,
        },
        axisLine: {
          roundCap: false,
          lineStyle: {
            width: 72,
            color: [[1, '#004D85']]
          }
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          show: false,
        },  
        title: {
          show: false
        },
        detail: {
          show: false,
        },
        data: [
          {
            value: 0,
          }
        ]
      }]
    });

    return { option };
  },
})
</script>